export default {
  strict: true,

  state: {
    // allowClosing can be set to false to disallow hiding the back drop on close, forcing it to be closed
    // programmatically. It's useful if we need to await a state, such as the checkout process.
    allowClosing: true,

    // message can be used to show states on top of the back drop.
    message: '',

    backdropIsShowing: false
  },

  mutations: {
    SET_ALLOW_CLOSING (state, allowClosing) {
      state.allowClosing = allowClosing
    },

    SET_MESSAGE (state, message) {
      state.message = message
    },

    SHOW_BACKDROP (state, showBackdrop) {
      state.backdropIsShowing = showBackdrop
    }
  },

  actions: {
    setAllowClosingBackdrop ({ commit }, allowClosing) {
      commit('SET_ALLOW_CLOSING', allowClosing)
    },

    setBackdropMessage ({ commit }, message) {
      commit('SET_MESSAGE', message)
    },

    showBackdrop ({ commit }, showBackdrop) {
      commit('SHOW_BACKDROP', showBackdrop)

      // Remove the message after the backdrop has closed.
      if (!showBackdrop) {
        let f = function () {
          commit('SET_MESSAGE', '')
        }
        setTimeout(f, 200) // @todo Backdrop timeout?
      }
    }
  },

  getters: {
    backdropAllowClosing (state) { return state.allowClosing },
    backdropIsShowing (state) { return state.backdropIsShowing },
    backdropMessage (state) { return state.message }
  }
}



// WEBPACK FOOTER //
// ./src/stores/backdrop.js